export default __webpack_public_path__ + "static/media/ramp_walkthrough_2.ac930a0f.bin";